/**
 * @generated SignedSource<<337bf6e5943d3709e66cd346ae21761e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_item$data = {
  readonly dealerDetailsDisplayInfo?: {
    readonly ctas: {
      readonly showMakeOffer: boolean | null;
    } | null;
  } | null;
  readonly seller: {
    readonly activeTimeAway: {
      readonly endDate: string | null;
    } | null;
    readonly isAccessible: boolean | null;
    readonly isRewardsTier2: boolean | null;
    readonly liveStorefrontProfile: {
      readonly aboutUsUnbranded: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsHeader_seller" | "PdpSharedSellerBrandingInfo_seller" | "PdpSharedSellerDetailsBio_seller" | "PdpSharedSellerDetailsReviewContainer_seller" | "PdpSharedSellerDistinction_seller" | "PdpSharedSellerInfo_seller" | "SellerAwayBanner_seller">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_item" | "PdpSharedCallDealerCta_item" | "PdpSharedSellerTabsVariant_item">;
  readonly " $fragmentType": "PdpRespDealerDetails_item";
};
export type PdpRespDealerDetails_item$key = {
  readonly " $data"?: PdpRespDealerDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_item",
  "selections": [
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedCallDealerCta_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContactDealerInlineForm_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerTabsVariant_item"
        },
        {
          "alias": "dealerDetailsDisplayInfo",
          "args": null,
          "concreteType": "ItemDisplayInfo",
          "kind": "LinkedField",
          "name": "displayInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CTADisplay",
              "kind": "LinkedField",
              "name": "ctas",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "showMakeOffer",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerTimeAway",
          "kind": "LinkedField",
          "name": "activeTimeAway",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SellerAwayBanner_seller"
        },
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedSellerDetailsReviewContainer_seller"
            }
          ]
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerDetailsBio_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerDetailsHeader_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerBrandingInfo_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerDistinction_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerInfo_seller"
        },
        {
          "alias": "isRewardsTier2",
          "args": [
            {
              "kind": "Literal",
              "name": "listName",
              "value": "SELLER_REWARDS_2"
            }
          ],
          "kind": "ScalarField",
          "name": "isAnchorListMember",
          "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StorefrontProfile",
          "kind": "LinkedField",
          "name": "liveStorefrontProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "aboutUsUnbranded",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "dd6f6d13d59c8037e52d93afd04761f3";

export default node;
